// src/DeviceModal.js

import { useEffect, useMemo, useState } from "react";
import "./device-modal.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IoMdDocument } from "react-icons/io";
import { FaWifi } from "react-icons/fa";
import { GiNetworkBars } from "react-icons/gi";
import { CiBatteryFull, CiPhone, CiVideoOn } from "react-icons/ci";
import { BiSolidShare } from "react-icons/bi";
import { FaFilePdf } from "react-icons/fa6";

const DeviceModal = ({ handleClose, templateId }) => {
  const ApiBaseURL = import.meta.env.VITE_API_BASE_URL;
  const token = localStorage.getItem("authToken");
  const [template, setTemplate] = useState();
  const [media, setMedia] = useState();
  const navigate = useNavigate();
  const companyName = localStorage.getItem("CompanyName");
  const [isOnline, setIsOnline] = useState(true);

  const getSingleTemplate = async () => {
    try {
      const response = await axios.get(
        `${ApiBaseURL}AgentTemplate/GetSingleAgentTemplateDetails?TempId=${templateId}`);
      if (response.status === 200) {
        const { Templates, Attachments } = response?.data;
        setTemplate(Templates[0]);
        setMedia(Attachments);
      }
    } catch (error) {
      navigate("/userchat");
      console.log("Error fetching the data", error);
    }
    return [];
  };

  useEffect(() => {
    const fetchData = async () => {
      if (templateId) {
        await getSingleTemplate();
      }
    };
    fetchData();
  }, [templateId]);

  const renderVideoTemplate = useMemo(() => {
    return (data) => {
      if (data[0]) {
        return data?.length > 1 ? (
          data?.map((vid, i) => {
            if (i < 4) {
              return (
                <video
                  key={i}
                  src={vid.LiveURL}
                  className="w-1/2 h-auto border border-white aspect-video rounded"
                  playsInline
                />
              );
            }
          })
        ) : (
          <>
            {data[0] && (
              <video
                src={data[0].LiveURL}
                className="w-full h-auto border border-white aspect-video rounded"
                playsInline
              />
            )}
          </>
        );
      }
    };
  });

  const renderLocationMap = () => {
    return (
      <iframe
        src={`https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7010.326143872807!2d${template?.longitude}!3d${template?.latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1729337485848!5m2!1sen!2sin`}
        height={300}
        style={{ border: 0, margin: "0 auto" }}
        className="min-full"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    );
  };

  const renderDocument = (data) => {
    if (data[0]) {
      return data?.length > 1 ? (
        data?.map((doc, i) => {
          if (i < 4) {
            return (
              <div className="w-1/2 justify-center" key={i}>
                <FaFilePdf className="text-red-500" size={60} />
              </div>
            );
          }
        })
      ) : (
        <IoMdDocument size={80} />
      );
    }
  };

  const renderImageTemplate = (data) => {
    if (data[0]) {
      return data?.length > 1 ? (
        data?.map((img, i) => {
          if (i < 4) {
            return (
              <img
                key={i}
                src={img.LiveURL}
                alt="Template Image"
                className={`w-1/2 h-auto rounded aspect-square object-cover border border-white`}
              />
            );
          }
        })
      ) : (
        <>
          {data[0] && (
            <img
              src={data[0].LiveURL}
              alt="Template Image"
              className="w-full h-auto mb-2 rounded aspect-square object-cover border border-white"
            />
          )}
        </>
      );
    }
  };
  // Template Render Code End

  return (
    <>
      <div id="phone" className="relative">
        <div id="device-display">
          <div id="content">
            <div className="relative">
              <div className="flex justify-between mx-4 py-2">
                <p>10:49 Am</p>

                <div className="flex gap-2">
                  <span>
                    <FaWifi />
                  </span>
                  <span>
                    <GiNetworkBars />
                  </span>
                  <span>
                    <CiBatteryFull size={20} />
                  </span>
                </div>
              </div>
              <div className="user-bar flex justify-between gap-2 py-2 mx-4">
                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center shadow-outline">
                    <img src="/logo.png" alt="logo" className="w-14" />
                  </div>
                  <div>
                    <h5 className="text-sm md:text-md font-medium">{companyName}</h5>
                    <div className="flex items-center">
                      <div
                        className={`w-2 h-2 rounded-full mr-1 ${isOnline ? "bg-green-500" : "bg-gray-400"
                          }`}
                      ></div>
                      <span className="text-xs text-gray-500">
                        {isOnline ? "Online" : "Offline"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2 items-center justify-center">
                  <p>
                    <CiVideoOn size={26} className="text-blue-400" />
                  </p>
                  <p>
                    <CiPhone size={26} className="text-blue-400" />
                  </p>
                </div>
              </div>
              <div className="relative min-h-[30rem] md:min-h-[37rem]">
                <p className="min-full text-lg bg-gray-100 shadow-md rounded-lg mx-2 py-2 p-2">
                  {template?.TemplateText}
                </p>
                <div className="min-full flex flex-col pt-4">
                  <div className="min-w-64 flex flex-wrap mx-auto">
                    {template?.TemplateType === "Image" &&
                      renderImageTemplate(media)}
                    {template?.TemplateType === "Video" &&
                      renderVideoTemplate(media)}
                    {template?.TemplateType === "Location" &&
                      renderLocationMap()}
                    {template?.TemplateType === "Document" &&
                      renderDocument(media)}
                  </div>
                  {template && (
                    <div className="mx-auto flex gap-3 mt-2">
                      {template.Button1Title && (
                        <div className="mt-4 text-center flex items-center justify-center cursor-pointer">
                          <BiSolidShare className="text-l mr-2 text-blue-800" />
                          <span className="text-blue-800">
                            {template.Button1Title}
                          </span>
                        </div>
                      )}
                      {template.Button2Title && (
                        <div className="mt-4 text-center flex items-center justify-center cursor-pointer">
                          <BiSolidShare className="text-l mr-2 text-blue-800" />
                          <span className="text-blue-800">
                            {template.Button2Title}
                          </span>
                        </div>
                      )}
                      {template.Button3Title && (
                        <div className="mt-4 text-center flex items-center justify-center cursor-pointer">
                          <BiSolidShare className="text-l mr-2 text-blue-800" />
                          <span className="text-blue-800">
                            {template.Button3Title}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="absolute bottom-[1rem] bg-black text-white text-lg font-semibold rounded px-3 p-1 left-1/2 -translate-x-1/2 z-90"
          size={22}
          onClick={handleClose}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default DeviceModal;
